import {useTheme} from "../../UI/Theme/ThemeContext";
import {ButtonActionStyled, EduCardStyled} from "../../../styled/Resume";
import InputHandler from "./InputHandler";
import {MdDelete} from "react-icons/md";
import {FaPlus} from "react-icons/fa6";
import React from "react";


const PublicationCard = (props)=> {
    const {
        publications,
        handlePubChange,
        handleDeletePublication,
        handleAddPublication,

    } = props;

    const {themeName} = useTheme();

    return (
        <div className="eduContainer">
            {
                publications.map((info, index) => (
                    <EduCardStyled key={index} theme={themeName}>
                        <div className="inputs">
                            <InputHandler
                                name="title"
                                id={info.title + index}
                                value={info.title}
                                type="text"
                                label="Title"
                                required={true}
                                onChange={(event) => handlePubChange(event, index)}
                            />
                            <InputHandler
                                name="source"
                                id={info.source + index}
                                value={info.source}
                                type="text"
                                label="Source"
                                required={true}
                                onChange={(event) => handlePubChange(event, index)}
                            />
                            <InputHandler
                                name="date"
                                id={info.date + index}
                                value={info.date}
                                type="date"
                                label="Date Awarded"
                                required={true}
                                onChange={(event) => handlePubChange(event, index)}
                            />
                        </div>
                        <ButtonActionStyled>
                            <span className="del" onClick={handleDeletePublication}> <MdDelete/> </span>
                            <span className="add" onClick={handleAddPublication}> <FaPlus/> </span>
                        </ButtonActionStyled>

                    </EduCardStyled>

                ))
            }

        </div>
    )
}

export default PublicationCard;